import { render, staticRenderFns } from "./ItemPackBaseData.vue?vue&type=template&id=6eb6f807&scoped=true"
import script from "./ItemPackBaseData.vue?vue&type=script&lang=js"
export * from "./ItemPackBaseData.vue?vue&type=script&lang=js"
import style0 from "./ItemPackBaseData.vue?vue&type=style&index=0&id=6eb6f807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6f807",
  null
  
)

export default component.exports